// Fullscreen helper functions
export const exitFullscreen = () => {
  const doc = document as Document & {
    mozCancelFullScreen?: () => Promise<void>;
    webkitExitFullscreen?: () => Promise<void>;
    msExitFullscreen?: () => Promise<void>;
  };

  if (doc.exitFullscreen) {
    void doc.exitFullscreen();
  } else if (doc.webkitExitFullscreen) {
    void doc.webkitExitFullscreen();
  } else if (doc.mozCancelFullScreen) {
    void doc.mozCancelFullScreen();
  } else if (doc.msExitFullscreen) {
    void doc.msExitFullscreen();
  }
};

export const enterFullscreen = (
  videoElement: HTMLVideoElement,
  containerElement: HTMLDivElement
) => {
  // Try video element fullscreen first (for iOS and mobile devices)
  const video = videoElement as HTMLVideoElement & {
    webkitEnterFullscreen?: () => void;
    webkitSupportsFullscreen?: boolean;
  };

  if (video.webkitEnterFullscreen && video.webkitSupportsFullscreen) {
    try {
      video.webkitEnterFullscreen();
      return;
    } catch {
      // Fall through to container fullscreen
    }
  }

  // Try container fullscreen with all vendor prefixes
  const container = containerElement as HTMLDivElement & {
    mozRequestFullScreen?: () => Promise<void>;
    webkitRequestFullscreen?: () => Promise<void>;
    msRequestFullscreen?: () => Promise<void>;
  };

  if (container.requestFullscreen) {
    void container.requestFullscreen();
  } else if (container.webkitRequestFullscreen) {
    void container.webkitRequestFullscreen();
  } else if (container.mozRequestFullScreen) {
    void container.mozRequestFullScreen();
  } else if (container.msRequestFullscreen) {
    void container.msRequestFullscreen();
  }
};
